import './appBarStyles.css'
import { Button } from '@atd/rui-base.mui.button'

import * as administrationActions from '../admin/administrationActions'

import React, { useEffect, useState } from 'react'
import { getApps, getHost } from '../lib/redirect'
import {useDispatch, useSelector} from 'react-redux'

import { AppsHeader } from '@atd/one-slingshot.components.apps-header'
import Cookies from 'universal-cookie'
import { TrackJS } from 'trackjs'
import axios from 'axios'
import { jwtDecode } from 'jwt-decode'
import {searchQueryString} from '../workorder/queryString'

const createNavSections = ({
    showServiceMenu,
}) => ([
    {
        navLinks: [
            {
                name: 'GFF Manager',
                href: '/gff-manager',
                active: window.location.pathname === '/gff-manager',
            },
            {
                name: 'Job Generator',
                href: '/jobs/create',
                active: window.location.pathname === '/jobs/create',
            },
            {
                name: 'Job List',
                href: '/jobs/list',
                // no active, this is covered by the main menu section and we don't want two lines highlighted
            },
            {
                name: 'Mix Manager',
                href: '/mix-manager',
                active: window.location.pathname === '/mix-manager',
            },
        ],
    },
    ...(showServiceMenu ? [{
        navLinks: [
            {
                name: 'Bundle Management',
                href: `https://${getApps()}/bundles`,
                active: window.location.pathname === '/bundles',
            },
            {
                name: 'Job Sync Debug',
                href: '/jobs/job-sync-debug',
                active: window.location.pathname === '/jobs/job-sync-debug',
            },
        ],
    }] : []),
])

const AppBarSlingShot = ({
    pageTitle = 'Slingshot',
}) => {
    const dispatch = useDispatch()
    const adminStore = useSelector(store => store.admin)
    const auth0Store = useSelector(store => store.auth0)

    const {availableCompanies, selectedCompanyId, cloaked, languages, unitsOfMeasurement, userPreferences, contactInfo} = adminStore

    const sortedCompanies = []
    if (Array.isArray(availableCompanies)) {
        sortedCompanies.push(...availableCompanies)
        sortedCompanies.sort((a, b) => {
            if (a.companyName < b.companyName) return -1
            if (a.companyName > b.companyName) return 1

            return 0
        })
    }

    const [urlCompanyID, setUrlCompanyID] = useState(null)

    const serviceAccess = administrationActions.userHasRavenServiceAccess()
    const engineeringAccess = administrationActions.userHasDeveloperAccess()

    const checkSelectedCompany = (companies = availableCompanies, scid = selectedCompanyId) => {
        // Wait until we have received a list of companies from our backend to validate the selected company ID.
        if (!companies) { return }

        TrackJS.console.debug('Available Companies', companies)
        if (companies.length > 0) {
            if (scid && companies.find(company => { return company.id === scid })) {
                if (selectedCompanyId !== scid) {
                    dispatch(administrationActions.selectCompany(scid))
                }
            }
            else {
                dispatch(administrationActions.selectCompany(companies[0].id))
            }
        }
        else if (scid) {
            dispatch(administrationActions.selectCompany(null))
        }
    }

    const handleCompanySelect = (value) => {
        if (value.id != selectedCompanyId) {
            dispatch(administrationActions.selectCompany(value.id))
            dispatch(administrationActions.isJobFilterFromURL(false))
            setUrlCompanyID(value.id)
            TrackJS.addMetadata('selectedCompanyId', value.id)
        }
    }

    const handleUncloak = (event) => {
        if (event === 'clickaway') { return }

        const { isAuth0Enabled } = auth0Store.authTypeReducer
        // User id param is optional, setting it to zero for backwards compatibility
        let userId = 0
        if (!isAuth0Enabled) {
            // Portal
            const cookies = new Cookies()
            const userInfo = jwtDecode(cookies.get('jwt'))
            userId = userInfo.user_id
        }

        const host = getHost()
        const portalUrl = `https://${host}/index.php?r=site/unCloakUser&original_user_party_id=${userId}`
        const uninterceptedAxiosInstance = axios.create()
        uninterceptedAxiosInstance.get(portalUrl)
        dispatch(administrationActions.uncloak())
    }

    const renderCloak = () => {
        if (cloaked?.username) {
            return (
                <div name="cloakHeader" className="cloakWrapper">
                    <div className="cloakStatus">
                        Currently cloaking {cloaked.username} ({cloaked.id}).
                        <Button variant="text"
                            key="close"
                            onClick={handleUncloak}>Uncloak</Button>
                    </div>
                </div>
            )
        }
    }

    const navSections = createNavSections({
        showServiceMenu: serviceAccess,
    })

    const companySelect = {
        label: '',
        value: {
            id: urlCompanyID || selectedCompanyId,
            label: sortedCompanies.find(company => company.id === (urlCompanyID || selectedCompanyId))?.companyName || 'Unknown',
        },
        onChange: handleCompanySelect,
        items: sortedCompanies.map(company => ({label: company.companyName, id: company.id})),
    }

    const userPrefs = {
        language: userPreferences.language,
        unitOfMeasurement: userPreferences.unitOfMeasurement,
        mapRefreshInterval: userPreferences.mapRefreshIntervalMilliseconds,
        sessionTimeout: userPreferences.idleSessionTimeoutSeconds,
    }

    const onSave = async(userPreferences) => {
        const result = await dispatch(administrationActions.saveUserPreferences({
            language: userPreferences.language,
            unitOfMeasurement: userPreferences.unitOfMeasurement,
            mapRefreshIntervalMilliseconds: userPreferences.mapRefreshInterval,
            idleSessionTimeoutSeconds: userPreferences.sessionTimeout,
            newPassword: userPreferences.newPassword,
        }))

        return result
    }

    useEffect(() => {
        dispatch(administrationActions.fetchFileTypes())
        dispatch(administrationActions.fetchLanguages())
        dispatch(administrationActions.fetchUnitsOfMeasurement())
        dispatch(administrationActions.fetchUserPreferences())
        dispatch(administrationActions.fetchContactInfo())

        dispatch(administrationActions.fetchCompanyInfo()).then((companies) => {
            const selectedCompanyId = administrationActions.getSelectedCompanyCookie()
            checkSelectedCompany(companies.availableCompanies, selectedCompanyId)
        }).catch(() => { dispatch(administrationActions.selectCompany(null)) })
    }, [])

    useEffect(() => {
        checkSelectedCompany(availableCompanies, selectedCompanyId)
    }, [availableCompanies, selectedCompanyId])

    useEffect(() => {
        dispatch(administrationActions.isJobFilterFromURL(true))
        const id = parseInt(searchQueryString('selectedCompanyId'), 10)
        if (id && !isNaN(id)) {
            setUrlCompanyID(id)
            dispatch(administrationActions.selectCompany(id))
        }
    }, [])


    const userAccountInfo = {
        name: contactInfo.firstName + ' ' + contactInfo.lastName,
        email: contactInfo.emailAddress,
    }

    return (
        <div id="app-bar">
            {renderCloak()}
            <AppsHeader
                pageTitle={pageTitle}
                showEngineeringMenu={engineeringAccess}
                showServiceMenu={serviceAccess}
                bottomNavTitle={'Job List Shortcuts'}
                bottomNavSections={navSections}
                companySelectProps={companySelect}
                languages={languages.map(l => ({label: l.name, value: l.code}))}
                unitsOfMeasure={unitsOfMeasurement.map(uom => ({label: uom, value: uom}))}
                userPreferences={userPrefs}
                saveUserPreferences={onSave}
                userAccountInfo={userAccountInfo}
            />
        </div>
    )
}

export default AppBarSlingShot
